import React from "react"
import { Navigate, Route, Routes as SwitchRoutes, useLocation, useNavigate } from "react-router-dom"
import { Box, Button, Grid } from "@mui/material"
import HeaderRoot from "../../components/HeaderRoot"
import Bookmanagement from "./Bookmanagement"
import Lizenzen from "./Lizenzen"
import { F_VERWALTUNG_BOOKS, F_VERWALTUNG_BOOKS_SHORT, F_VERWALTUNG_LICENCES, F_VERWALTUNG_LICENCES_SHORT } from "../../constants/routes"

const TabList = [
  {
    name: "Bücherlisten",
    route: F_VERWALTUNG_BOOKS,
  },
  {
    name: "Lizenzen",
    route: F_VERWALTUNG_LICENCES,
  },
]

const Schuladmin = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const headerContent = (
    <Grid container spacing="4vh">
      {TabList.map((t) => (
        <Grid container justifyContent="flex-end" item xs={12} columns={10} key={t.name}>
          <Grid item xs={8}>
            <Button
              variant="contained"
              onClick={() => navigate(t.route)}
              sx={{
                height: "8vh",
                width: "100%",
                // mx: "10%",
                textTransform: "none",
                boxShadow: "none",
                backgroundColor: location.pathname === t.route ? "white" : "bmsecondary.main",
                color: location.pathname === t.route ? "bmsecondary.main" : "white",
                "&:hover": { backgroundColor: "inherit" },
              }}>
              {t.name}
            </Button>
          </Grid>

          <Grid item xs={1}>
            <Box
              sx={{
                backgroundColor: "white",
                height: "8vh",
                width: "100%",
                visibility: location.pathname === t.route ? "visible" : "hidden",
              }}></Box>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )

  return (
    <Box sx={{ height: "100vh", width: "100vw", backgroundColor: "bmprimary.main" }}>
      <HeaderRoot content={headerContent} showUserMenu bookmanagement />
      <SwitchRoutes location={location}>
        <Route path="/" element={<Navigate to={F_VERWALTUNG_BOOKS} replace />} />

        <Route path={F_VERWALTUNG_BOOKS_SHORT} element={<Bookmanagement />} />
        <Route path={F_VERWALTUNG_LICENCES_SHORT} element={<Lizenzen />} />

        {/* <Route path="*" element={<Bookmanagement />} /> */}
      </SwitchRoutes>
    </Box>
  )
}

export default Schuladmin
